import { Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { useGetUsersQuery } from '../../../../../../../../../../store/api/users-api'

interface InitiatorProps {}

const Initiator: FC<InitiatorProps> = () => {
    const name = 'initiator'
    const { data } = useGetUsersQuery()

    return (
        <Form.Item name={name} label={'Менеджер'}>
            <Select
                options={data?.map(item => ({ value: item.documentId, label: item.username }))}
            />
        </Form.Item>
    )
}

export default Initiator
